module.exports = __webpack_public_path__ + "img/banner-bg-1.9c6e6645.png";